import { useQuery } from "@tanstack/react-query";
import { getCmsFileBlob } from "../api/cmsApi";
import { cmsKeys } from "../api/cmsKeys";

// Query dependiente: descarga el PDF del manifiesto como Blob una vez que se
// conoce su fileId. Devuelve el Blob; el object URL lo maneja la page.
export const useManifestPdf = (fileId?: string, extension?: string) =>
  useQuery({
    queryKey: cmsKeys.file(fileId, extension),
    queryFn: () => getCmsFileBlob(fileId as string, extension as string),
    enabled: Boolean(fileId && extension),
  });
